import TiebreakerDefaults from "../constants/TiebreakerDefaults";
import { getGameResults } from "./GetGameResults";

export const getPouleScores = (
  tournament,
  matches,
  poule,
  scoresPerTeamAll = undefined,
  headToHead = false
) => {
  let scoreType =
    poule.scoreType ||
    (poule.bracket
      ? (tournament.scoringTypesPerBracket || {})[poule.bracket] || {}
      : false) ||
    ((tournament.scoringTypesPerDivisionPerPhase || {})[poule.division] || {})[
      poule.fase
    ] ||
    "default";
  let scoring =
    scoreType === "default"
      ? tournament
      : (tournament.scoringTypes || {})[scoreType] || tournament;

  const useSets = (scoring.useSets || "0") === "1";
  const setsType = scoring.setsType || 0;

  let tiebreakers = [];
  if (scoring.tiebreakers !== undefined) {
    tiebreakers = scoring.tiebreakers.filter((t) =>
      t.custom ? (tournament.customPoints || {})[t.id] !== undefined : true
    );
  } else if (useSets) {
    tiebreakers = TiebreakerDefaults["2"].criteria;
  } else if (
    (scoring.scoreCalculationType === undefined ||
      scoring.scoreCalculationType === 0) &&
    scoring.tiebreakerCriteria === undefined
  ) {
    tiebreakers = TiebreakerDefaults["0"].criteria;
  } else if (scoring.scoreCalculationType === 1) {
    tiebreakers = TiebreakerDefaults["1"].criteria;
  }

  const headToHeadIndex = tiebreakers.findIndex((t) => t.id === "headToHead");
  let tiebreakers1 = tiebreakers;
  let tiebreakers2 = [];
  if (headToHeadIndex !== -1) {
    tiebreakers1 = tiebreakers.slice(0, headToHeadIndex);
    tiebreakers2 = tiebreakers.slice(headToHeadIndex);
  }
  tiebreakers = tiebreakers1;
  if (headToHead) {
    tiebreakers = tiebreakers2;
  }

  let pointsBigWin = scoring.pointsBigWin ? Number(scoring.pointsBigWin) : 3;
  let pointsBigWinMargin = scoring.pointsBigWinMargin
    ? Number(scoring.pointsBigWinMargin)
    : 2;
  let pointsWinOnPenalties = scoring.pointsWinOnPenalties
    ? Number(scoring.pointsWinOnPenalties)
    : 3;
  let pointsWin = scoring.pointsWin ? Number(scoring.pointsWin) : 3;
  let pointsTie = scoring.pointsTie ? Number(scoring.pointsTie) : 1;
  let pointsTieNoGoals = scoring.pointsTieNoGoals
    ? Number(scoring.pointsTieNoGoals)
    : 1;
  let pointsLose = scoring.pointsLoss ? Number(scoring.pointsLoss) : 0;
  let pointsLossOnPenalties = scoring.pointsLossOnPenalties
    ? Number(scoring.pointsLossOnPenalties)
    : 0;
  const goalsAsPoints =
    (scoring.goalsAsPoints &&
      (scoring.advancedGroupRanking ||
        scoring.advancedGroupRanking === undefined)) ||
    false;
  const initialScores = {
    played: 0,
    won: 0,
    tie: 0,
    loss: 0,
    pouleScore: 0,
    goals: 0,
    goalsFor: 0,
    goalsAgainst: 0,

    cleanSheets: 0,

    // sets
    sets: 0,
    setsFor: 0,
    setsAgainst: 0,
  };

  Object.keys(tournament.customPoints || {}).forEach((key) => {
    initialScores[key] = 0;
  });

  const scoresPerTeam = {};
  for (let m in matches) {
    const match = matches[m];
    const team1 = match.team1;
    const team2 = match.team2;

    let gameResults = getGameResults(scoring, match.sets || {});
    let gameScore1 = gameResults.result1;
    let gameScore2 = gameResults.result2;
    let totalScore1 = gameResults.totalScore1;
    let totalScore2 = gameResults.totalScore2;
    let sets1 = gameResults.sets1;
    let sets2 = gameResults.sets2;
    const finished = gameResults.finished;

    if (scoresPerTeam[team1] === undefined) {
      // set initial scores
      scoresPerTeam[team1] = Object.assign({}, initialScores);
    }
    if (scoresPerTeam[team2] === undefined) {
      scoresPerTeam[team2] = Object.assign({}, initialScores);
    }

    if (useSets && setsType === 0) {
      let resultString =
        gameScore1 > gameScore2
          ? gameScore1.toString() + "-" + gameScore2.toString()
          : gameScore2.toString() + "-" + gameScore1.toString();
      pointsWin = Number(
        ((scoring.gamePoints || {})[resultString] || {}).winner || "2"
      );
      if (gameScore1 === gameScore2) {
        pointsTie = Number(
          ((scoring.gamePoints || {})[resultString] || {}).winner || "1"
        );
      }
      pointsLose = Number(
        ((scoring.gamePoints || {})[resultString] || {}).loser || "0"
      );
    }

    let score1 = useSets ? totalScore1 : match.score1;
    let score2 = useSets ? totalScore2 : match.score2;

    if (useSets ? finished : match.score1 !== null && match.score2 !== null) {
      scoresPerTeam[team1]["played"]++;
      scoresPerTeam[team1]["goals"] += score1;
      scoresPerTeam[team1]["goals"] -= score2;
      scoresPerTeam[team1]["goalsFor"] += score1;
      scoresPerTeam[team1]["goalsAgainst"] += score2;
      scoresPerTeam[team1]["sets"] += sets1;
      scoresPerTeam[team1]["sets"] -= sets2;
      scoresPerTeam[team1]["setsFor"] += sets1;
      scoresPerTeam[team1]["setsAgainst"] += sets2;
      scoresPerTeam[team2]["played"]++;
      scoresPerTeam[team2]["goals"] += score2;
      scoresPerTeam[team2]["goals"] -= score1;
      scoresPerTeam[team2]["goalsFor"] += score2;
      scoresPerTeam[team2]["goalsAgainst"] += score1;
      scoresPerTeam[team2]["sets"] += sets2;
      scoresPerTeam[team2]["sets"] -= sets1;
      scoresPerTeam[team2]["setsFor"] += sets2;
      scoresPerTeam[team2]["setsAgainst"] += sets1;

      if (score1 === 0) {
        scoresPerTeam[team2]["cleanSheets"] += 1;
      }
      if (score2 === 0) {
        scoresPerTeam[team1]["cleanSheets"] += 1;
      }

      if (useSets ? gameScore1 > gameScore2 : match.score1 > match.score2) {
        let pointsForThisWin = pointsWin;
        let isBigWin =
          match.score1 - match.score2 >= pointsBigWinMargin &&
          scoring.advancedGroupRanking;
        if (isBigWin) {
          pointsForThisWin = pointsBigWin;
        }
        scoresPerTeam[team1]["won"]++;
        scoresPerTeam[team1]["pouleScore"] += useSets
          ? setsType === 0
            ? pointsWin
            : gameScore1
          : goalsAsPoints
          ? match.score1
          : pointsForThisWin;

        scoresPerTeam[team2]["loss"]++;
        scoresPerTeam[team2]["pouleScore"] += useSets
          ? setsType === 0
            ? pointsLose
            : gameScore2
          : goalsAsPoints
          ? match.score2
          : pointsLose;
      } else if (
        useSets ? gameScore1 < gameScore2 : match.score1 < match.score2
      ) {
        let pointsForThisWin = pointsWin;
        let isBigWin =
          match.score2 - match.score1 >= pointsBigWinMargin &&
          scoring.advancedGroupRanking;
        if (isBigWin) {
          pointsForThisWin = pointsBigWin;
        }
        scoresPerTeam[team2]["won"]++;
        scoresPerTeam[team2]["pouleScore"] += useSets
          ? setsType === 0
            ? pointsWin
            : gameScore2
          : goalsAsPoints
          ? match.score2
          : pointsForThisWin;

        scoresPerTeam[team1]["loss"]++;
        scoresPerTeam[team1]["pouleScore"] += useSets
          ? setsType === 0
            ? pointsLose
            : gameScore1
          : goalsAsPoints
          ? match.score1
          : pointsLose;
      } else {
        if (
          scoring.advancedGroupRanking &&
          scoring.noDraw &&
          scoring.enterPenaltyScores &&
          scoring.includePenaltiesInGoals &&
          !useSets
        ) {
          scoresPerTeam[team1]["goals"] += match.penalties1 || 0;
          scoresPerTeam[team1]["goals"] -= match.penalties2 || 0;
          scoresPerTeam[team1]["goalsFor"] += match.penalties1 || 0;
          scoresPerTeam[team1]["goalsAgainst"] += match.penalties2 || 0;

          scoresPerTeam[team2]["goals"] += match.penalties2 || 0;
          scoresPerTeam[team2]["goals"] -= match.penalties1 || 0;
          scoresPerTeam[team2]["goalsFor"] += match.penalties2 || 0;
          scoresPerTeam[team2]["goalsAgainst"] += match.penalties1 || 0;
        }
        if (
          match.winner === team1 &&
          scoring.advancedGroupRanking &&
          scoring.noDraw &&
          !useSets
        ) {
          scoresPerTeam[team1]["won"]++;
          scoresPerTeam[team1]["pouleScore"] += goalsAsPoints
            ? match.score1
            : pointsWinOnPenalties;

          scoresPerTeam[team2]["loss"]++;
          scoresPerTeam[team2]["pouleScore"] += goalsAsPoints
            ? match.score2
            : pointsLossOnPenalties;
        } else if (
          match.winner === team2 &&
          scoring.advancedGroupRanking &&
          scoring.noDraw &&
          !useSets
        ) {
          scoresPerTeam[team1]["loss"]++;
          scoresPerTeam[team1]["pouleScore"] += goalsAsPoints
            ? match.score1
            : pointsLossOnPenalties;

          scoresPerTeam[team2]["won"]++;
          scoresPerTeam[team2]["pouleScore"] += goalsAsPoints
            ? match.score2
            : pointsWinOnPenalties;
        } else {
          scoresPerTeam[team1]["tie"]++;
          scoresPerTeam[team1]["pouleScore"] += useSets
            ? setsType === 0
              ? pointsTie
              : gameScore1
            : goalsAsPoints
            ? match.score1
            : match.score1 === 0 && scoring.advancedGroupRanking
            ? pointsTieNoGoals
            : pointsTie;

          scoresPerTeam[team2]["tie"]++;
          scoresPerTeam[team2]["pouleScore"] += useSets
            ? setsType === 0
              ? pointsTie
              : gameScore2
            : goalsAsPoints
            ? match.score2
            : match.score2 === 0 && scoring.advancedGroupRanking
            ? pointsTieNoGoals
            : pointsTie;
        }
      }
      // set winner if single match
      if (match.winner === team1) {
        scoresPerTeam[team1]["winner"] = true;
      } else if (match.winner === team2) {
        scoresPerTeam[team2]["winner"] = true;
      }

      // custom points
      Object.keys(match.extra1 || {}).forEach((key) => {
        if (scoresPerTeam[team1][key] !== undefined) {
          scoresPerTeam[team1][key] += Number(match.extra1[key] || 0);
          const customPoint = tournament.customPoints[key] || {};
          if (customPoint.addPointsToPouleScore) {
            scoresPerTeam[team1]["pouleScore"] += Number(
              match.extra1[key] || 0
            );
          }
        }
      });
      Object.keys(match.extra2 || {}).forEach((key) => {
        if (scoresPerTeam[team2][key] !== undefined) {
          scoresPerTeam[team2][key] += Number(match.extra2[key] || 0);
          const customPoint = tournament.customPoints[key] || {};
          if (customPoint.addPointsToPouleScore) {
            scoresPerTeam[team2]["pouleScore"] += Number(
              match.extra2[key] || 0
            );
          }
        }
      });
    }
  }
  let minusPoints = poule.minusPoints || {};
  Object.keys(minusPoints).forEach((key) => {
    if (scoresPerTeam[key] !== undefined) {
      scoresPerTeam[key]["pouleScore"] += minusPoints[key];
    }
  });
  let plusPoints = poule.plusPoints || {};
  Object.keys(plusPoints).forEach((key) => {
    if (scoresPerTeam[key] !== undefined) {
      scoresPerTeam[key]["pouleScore"] += plusPoints[key];
    }
  });

  if (scoresPerTeamAll === undefined) {
    scoresPerTeamAll = scoresPerTeam;
  }

  let scoresPerTeamArray = [];
  for (let i in scoresPerTeam) {
    let scores = scoresPerTeam[i];
    scores["teamKey"] = i;
    scoresPerTeamArray.push(scores);
  }

  let headToHeadTiebreakers = [];
  if (headToHead) {
    headToHeadTiebreakers = tiebreakers[0].subCriteria || [];
    scoresPerTeamArray.sort(createCompareForTiebreakers(headToHeadTiebreakers));
  } else {
    scoresPerTeamArray.sort(createCompareForTiebreakers(tiebreakers));
  }

  let sortedScores = [];
  var groups = groupBy(scoresPerTeamArray, (item) => {
    const groupCriteria = [];
    (headToHead ? headToHeadTiebreakers : tiebreakers).forEach((tiebreaker) => {
      groupCriteria.push(getCriteriumFromItem(item, tiebreaker));
    });
    return groupCriteria;
  });
  let checkWinner = false;
  for (let g in groups) {
    let undetermined = false;
    let group = groups[g];
    if (group.length > 1) {
      if (headToHeadIndex !== -1 && !headToHead) {
        const groupTeamKeys = group.map((g) => Number(g.teamKey));
        let matchesForBothTeams = matches.filter(
          (match) =>
            groupTeamKeys.indexOf(match.team1) > -1 &&
            groupTeamKeys.indexOf(match.team2) > -1
        );
        if (matchesForBothTeams.length > 0) {
          group = getPouleScores(
            tournament,
            matchesForBothTeams,
            poule,
            scoresPerTeamAll,
            true
          );
        }
      } else if (headToHead) {
        if (
          tiebreakers[0].applyRecursively &&
          group.length !== scoresPerTeamArray.length
        ) {
          const groupTeamKeys = group.map((g) => Number(g.teamKey));
          let matchesForBothTeams = matches.filter(
            (match) =>
              groupTeamKeys.indexOf(match.team1) > -1 &&
              groupTeamKeys.indexOf(match.team2) > -1
          );
          if (matchesForBothTeams.length > 0) {
            group = getPouleScores(
              tournament,
              matchesForBothTeams,
              poule,
              scoresPerTeamAll,
              true
            );
          }
        } else {
          group.sort(
            createCompareForTiebreakers(tiebreakers.slice(1), scoresPerTeamAll)
          );
          // check if group can be sorted
          const undeterminedGroups = groupBy(group, (item) => {
            const groupCriteria = [];
            const itemAll = scoresPerTeamAll[item.teamKey];
            if (itemAll) {
              tiebreakers.slice(1).forEach((tiebreaker) => {
                groupCriteria.push(getCriteriumFromItem(itemAll, tiebreaker));
              });
            }
            return groupCriteria;
          });
          for (let ug in undeterminedGroups) {
            const undeterminedGroup = undeterminedGroups[ug];
            if (undeterminedGroup.length > 1) {
              undetermined = true;
              if (poule.singleMatch) {
                checkWinner = true;
              }
            }
          }
        }
      } else {
        // group could not be sorted
        undetermined = true;
        if (poule.singleMatch) {
          checkWinner = true;
        }
      }
    }

    let undeterminedKey = "";
    if (undetermined) {
      undeterminedKey = (Math.random() + 1).toString(36).substring(7);
    }

    for (let t in group) {
      let team = group[t];
      let scores = scoresPerTeam[team.teamKey];
      scores["teamKey"] = team.teamKey;
      if (team.undetermined) {
        scores["undetermined"] = team.undetermined;
      }
      if (undetermined && !checkWinner) {
        scores["undetermined"] = undeterminedKey;
      }
      sortedScores.push(scores);
    }
  }

  if (poule.singleMatch && checkWinner) {
    if (sortedScores[1].winner) {
      sortedScores = [sortedScores[1], sortedScores[0]];
    }
  }
  return sortedScores;
};

const createCompareForTiebreakers = (
  tiebreakers,
  scoresPerTeamAll = undefined
) => {
  return function (a, b) {
    for (const tiebreaker of tiebreakers) {
      if (tiebreaker.id === "points") {
        let pouleScoreA = a.pouleScore;
        let pouleScoreB = b.pouleScore;
        if (scoresPerTeamAll) {
          pouleScoreA = (scoresPerTeamAll[a.teamKey] || {}).pouleScore;
          pouleScoreB = (scoresPerTeamAll[b.teamKey] || {}).pouleScore;
        }
        if (pouleScoreA > pouleScoreB) return -1;
        if (pouleScoreA < pouleScoreB) return 1;
      }
      if (tiebreaker.id === "goalDifference") {
        let goalsA = a.goals;
        let goalsB = b.goals;
        if (scoresPerTeamAll) {
          goalsA = (scoresPerTeamAll[a.teamKey] || {}).goals;
          goalsB = (scoresPerTeamAll[b.teamKey] || {}).goals;
        }
        if (goalsA > goalsB) return -1;
        if (goalsA < goalsB) return 1;
      }
      if (tiebreaker.id === "pointsRatio") {
        let pointsRatioA = a.goalsFor / a.goalsAgainst;
        let pointsRatioB = b.goalsFor / b.goalsAgainst;
        if (scoresPerTeamAll) {
          pointsRatioA =
            (scoresPerTeamAll[a.teamKey] || {}).goalsFor /
            (scoresPerTeamAll[a.teamKey] || {}).goalsAgainst;
          pointsRatioB =
            (scoresPerTeamAll[b.teamKey] || {}).goalsFor /
            (scoresPerTeamAll[b.teamKey] || {}).goalsAgainst;
        }
        if (pointsRatioA > pointsRatioB) return -1;
        if (pointsRatioA < pointsRatioB) return 1;
      }
      if (tiebreaker.id === "goalsScored") {
        let goalsForA = a.goalsFor;
        let goalsForB = b.goalsFor;
        if (scoresPerTeamAll) {
          goalsForA = (scoresPerTeamAll[a.teamKey] || {}).goalsFor;
          goalsForB = (scoresPerTeamAll[b.teamKey] || {}).goalsFor;
        }
        if (goalsForA > goalsForB) return -1;
        if (goalsForA < goalsForB) return 1;
      }
      if (tiebreaker.id === "numMatchesWon") {
        let wonA = a.won;
        let wonB = b.won;
        if (scoresPerTeamAll) {
          wonA = (scoresPerTeamAll[a.teamKey] || {}).won;
          wonB = (scoresPerTeamAll[b.teamKey] || {}).won;
        }
        if (wonA > wonB) return -1;
        if (wonA < wonB) return 1;
      }
      if (tiebreaker.id === "setDifference") {
        let setsA = a.sets;
        let setsB = b.sets;
        if (scoresPerTeamAll) {
          setsA = (scoresPerTeamAll[a.teamKey] || {}).sets;
          setsB = (scoresPerTeamAll[b.teamKey] || {}).sets;
        }
        if (setsA > setsB) return -1;
        if (setsA < setsB) return 1;
      }
      if (tiebreaker.id === "setRatio") {
        let setRatioA = a.setsFor / a.setsAgainst;
        let setRatioB = b.setsFor / b.setsAgainst;
        if (scoresPerTeamAll) {
          setRatioA =
            (scoresPerTeamAll[a.teamKey] || {}).setsFor /
            (scoresPerTeamAll[a.teamKey] || {}).setsAgainst;
          setRatioB =
            (scoresPerTeamAll[b.teamKey] || {}).setsFor /
            (scoresPerTeamAll[b.teamKey] || {}).setsAgainst;
        }
        if (setRatioA > setRatioB) return -1;
        if (setRatioA < setRatioB) return 1;
      }
      if (tiebreaker.id === "numSetsWon") {
        let setsForA = a.setsFor;
        let setsForB = b.setsFor;
        if (scoresPerTeamAll) {
          setsForA = (scoresPerTeamAll[a.teamKey] || {}).setsFor;
          setsForB = (scoresPerTeamAll[b.teamKey] || {}).setsFor;
        }
        if (setsForA > setsForB) return -1;
        if (setsForA < setsForB) return 1;
      }
      if (tiebreaker.id === "pointsAverage") {
        let pointsAverageA = a.pouleScore / a.played;
        let pointsAverageB = b.pouleScore / b.played;
        if (scoresPerTeamAll) {
          pointsAverageA =
            (scoresPerTeamAll[a.teamKey] || {}).pouleScore /
            (scoresPerTeamAll[a.teamKey] || {}).played;
          pointsAverageB =
            (scoresPerTeamAll[b.teamKey] || {}).pouleScore /
            (scoresPerTeamAll[b.teamKey] || {}).played;
        }
        if (pointsAverageA > pointsAverageB) return -1;
        if (pointsAverageA < pointsAverageB) return 1;
      }
      if (tiebreaker.id === "goalsConceded") {
        let goalsAgainstA = a.goalsAgainst;
        let goalsAgainstB = b.goalsAgainst;
        if (scoresPerTeamAll) {
          goalsAgainstA = (scoresPerTeamAll[a.teamKey] || {}).goalsAgainst;
          goalsAgainstB = (scoresPerTeamAll[b.teamKey] || {}).goalsAgainst;
        }
        if (goalsAgainstA > goalsAgainstB) return 1;
        if (goalsAgainstA < goalsAgainstB) return -1;
      }
      if (tiebreaker.id === "cleanSheets") {
        let cleanSheetsA = a.cleanSheets;
        let cleanSheetsB = b.cleanSheets;
        if (scoresPerTeamAll) {
          cleanSheetsA = (scoresPerTeamAll[a.teamKey] || {}).cleanSheets;
          cleanSheetsB = (scoresPerTeamAll[b.teamKey] || {}).cleanSheets;
        }
        if (cleanSheetsA > cleanSheetsB) return -1;
        if (cleanSheetsA < cleanSheetsB) return 1;
      }
      if (tiebreaker.custom) {
        let customA = a[tiebreaker.id] || 0;
        let customB = b[tiebreaker.id] || 0;
        if (scoresPerTeamAll) {
          customA = (scoresPerTeamAll[a.teamKey] || {})[tiebreaker.id] || 0;
          customB = (scoresPerTeamAll[b.teamKey] || {})[tiebreaker.id] || 0;
        }
        if (tiebreaker.desc) {
          if (customA > customB) return 1;
          if (customA < customB) return -1;
        } else {
          if (customA > customB) return -1;
          if (customA < customB) return 1;
        }
      }
    }
    return 0;
  };
};

function groupBy(array, f) {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

function getCriteriumFromItem(item, tiebreaker) {
  if (tiebreaker.id === "points") {
    return item.pouleScore;
  }
  if (tiebreaker.id === "goalDifference") {
    return item.goals;
  }
  if (tiebreaker.id === "pointsRatio") {
    const pointsRatio = item.goalsFor / item.goalsAgainst;
    return pointsRatio;
  }
  if (tiebreaker.id === "goalsScored") {
    return item.goalsFor;
  }
  if (tiebreaker.id === "numMatchesWon") {
    return item.won;
  }
  if (tiebreaker.id === "setDifference") {
    return item.sets;
  }
  if (tiebreaker.id === "setRatio") {
    const setRatio = item.setsFor / item.setsAgainst;
    return setRatio;
  }
  if (tiebreaker.id === "numSetsWon") {
    return item.setsFor;
  }
  if (tiebreaker.id === "pointsAverage") {
    const pointsAverage = item.pouleScore / item.played;
    return pointsAverage;
  }
  if (tiebreaker.id === "goalsConceded") {
    return item.goalsAgainst;
  }
  if (tiebreaker.id === "cleanSheets") {
    return item.cleanSheets;
  }
  if (tiebreaker.custom) {
    const custom = item[tiebreaker.id] || 0;
    return custom;
  }
}
